import { defineComponent as _defineComponent } from 'vue'
import { BaseText } from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { Money } from '@/modules/common/components/Money';
import { IProductDetailsInfo } from '@/modules/products/services/products';

interface Props {
  details: IProductDetailsInfo[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryCardProfitabilityFooter',
  props: {
    details: { default: () => [] }
  },
  setup(__props: any) {



return { __sfc: true,BaseText, NebraskaColors, Money }
}

})